<template>
  <div>
    <activity-flow-card
      card_title="Soporte de ventas"
      :data="reportData"
      :loading="loading"
      :mapData="{ title: 'Title', qty: 'Qty' }"
      @click-item-qty="handleClickLink"
    >
    </activity-flow-card>

    <rabbey-base-drawer
      :drawer.sync="drawer"
      size="80%"
      :title="title"
      :before-close="handlerClose"
    >
      <div v-if="title != 'Oportunidades Vencidas'">
        <CardStatDrawerHeader
          :itemQuantity="itemQuantity"
          :totalAmount="getTotalAmount"
        />

        <rabbey-toolbox :filterables="true" @filter-search="search = $event" />
        <rabbey-table3
          :data="items"
          :search="search"
          :columns="columns"
          :loading="tableLoading"
          :max-height="700"
          :page-sizes="[10, 30, 50, 100, 500]"
        ></rabbey-table3>
      </div>

      <div v-else>
        <el-row>
          <el-col>
            <rabbey-table3
              ref="table"
              :loading="loading"
              :data="OportuinitiesData"
              :columns="dueOportunitiesColumns"
              :actions="actions"
              @rtable-push-action="onPushAction"
            >
            </rabbey-table3>
          </el-col>
        </el-row>

        <DealsFormDrawer
          ref="form_view"
          :title="dealDetailTitle"
          :drawer.sync="dealDetailDrawer"
          :loading="true"
          :append-to-body="true"
          v-bind="dealDetailBind"
          @close-drawer="CloseDetailDrawer"
          @refresh-table="handleTableUpdate"
        />
      </div>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import axios from "axios";
import {
  dealSalesS,
  // dealColumns,
  // expiredDeals,
  diaryColumns,
  leadColumns
} from "@/columns";
import ActivityFlowCard from "@/components/activity_flow/ActivityFlowCard.vue";
import { helperGetColumsItems } from "./utils.js";
import CardStatDrawerHeader from "./CardStatDrawerHeader.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import DatetimeFormatterColor from "@/components/functionals/DatetimeFormatterColor.vue";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import DealsFormDrawer from "@/components/deals/DealsFormDrawer.vue";
import Deal from "@/models/deals/Deal";
import { formatMonto } from "@/utils";
//import DealReportDetail from "@/views/modules/sales/reports/DealReportDetail.vue";

/*
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
*/

export default {
  props: {
    employee: {
      type: [String, Number]
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActivityFlowCard,
    CardStatDrawerHeader,
    DealsFormDrawer
    // DealReportDetail
  },
  created() {
    this.getReportData();
  },
  data() {
    return {
      dealDetailTitle: "",
      dealDetailDrawer: false,
      dealDetailBind: {
        initModel: Deal
      },
      reportData: [],
      loading: false,
      tableLoading: false,
      drawer: false,
      title: "",
      search: "",
      OportuinitiesData: [],
      items: [],
      columns: [],
      dueOportunitiesColumns: [
        {
          prop: "Id",
          label: "NO",
          width: 70,
          align: "center",
          fixed: true
        },
        {
          prop: "Name",
          label: "Descripción de Oportunidad",
          minWidth: 240
        },
        {
          prop: "Quantity",
          label: "Cantidad",
          width: 110
        },
        {
          prop: "UnitPrice",
          label: "P. Unitario",
          width: 110
          // formatter: row => formatterMoney(row.UnitPrice)
        },
        {
          prop: "Amount",
          label: "Monto total",
          width: 100,
          formatter: (row) => formatMonto(row.Amount)
        },
        // {
        //   prop: "Currency.Name",
        //   label: "Moneda",
        //   width: 100
        //   // formatter: row => (row.Currency ? row.Currency.Name : "")
        // },
        {
          label: "Contacto",
          prop: "ContactName",
          minWidth: 100
        },
        {
          prop: "InitialDate",
          label: "Fecha de propuesta",
          formatter: DatetimeFormatter,
          width: 180
        },
        {
          prop: "FinalDate",
          label: "Fecha de cierre",
          formatter: DatetimeFormatterColor,
          width: 180
        },
        {
          prop: "Seller.FullName",
          label: "Vendedor",
          minWidth: 200,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "Seller.imageUrl"
          }
        },
        {
          prop: "SupportSellerName",
          label: "Soporte de venta",
          width: 250,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SupportSellerPhoto"
          }
        }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit",
          condition: () =>
            this.IsInRoles([
              this.roles.Admin,
              this.roles.SuperUsuario,
              this.roles.CEO,
              this.roles.SupervisorDeVentas,
              this.roles.SupervisorDeSoporteDeVentas
            ])
        }
      ],
      itemQuantity: 0,
      totalAmount: 0,
      request: null,
      mapColumns: {
        Leads: leadColumns,
        Deals: dealSalesS,
        Agenda: diaryColumns
      }
    };
  },
  computed: {
    getTotalAmount() {
      let total = 0;
      if (this.items) {
        this.items.forEach((i) => (total += i.Amount));
      }
      return total.toFixed(2);
    }
  },
  methods: {
    getReportData() {
      if (this.request) {
        this.request.cancel();
      }

      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetSalesSupportStat", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            UserName: this.currentUser.UserName,
            CompanyCode: this.currentCompany,
            SellerCode: this.currentUser.PersonCode,
            EmployeeId: this.employee
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          this.loading = false;
        })
        .catch((error) => console.error(error));
    },
    async onPushAction(c) {
      var { data } = await this.$http.get("/api/deals/GetByID/", {
        timeout: 3 * 60 * 1000,
        params: {
          DealsId: c.row.Id
        }
      });

      const isClient = data.CustomerCode
        ? data.CustomerCode.startsWith("CL")
        : false;
      const isProspect = data.CustomerCode
        ? data.CustomerCode.startsWith("C0")
        : false;
      const code = data.CustomerCode ?? "";

      switch (c.command) {
        case "view": {
          this.dealDetailTitle = `Detalle de Oportunidad # ${c.row.Id}`;
          this.dealDetailBind.isClient = isClient;
          this.dealDetailBind.isProspect = isProspect;
          this.dealDetailBind.code = code;
          this.dealDetailBind.initModel = JSON.parse(JSON.stringify(c.row));
          this.dealDetailBind.initModel = {
            ...data
          };
          this.dealDetailBind.isEdit = false;
          this.dealDetailBind.isView = true;
          this.dealDetailDrawer = true;
          break;
        }

        case "edit": {
          this.dealDetailTitle = `Detalle de Oportunidad # ${c.row.Id}`;
          this.dealDetailBind.isClient = isClient;
          this.dealDetailBind.isProspect = isProspect;
          this.dealDetailBind.code = code;
          this.dealDetailBind.initModel = {
            ...data
          };
          this.dealDetailBind.isView = false;
          this.dealDetailBind.isEdit = true;
          this.dealDetailDrawer = true;
          break;
        }

        default:
          break;
      }
    },
    handleClickLink(props) {
      this.tableLoading = true;
      //console.log("PROPS: ", props);
      const report = this.reportData.find((f) => f.Title === props.title);
      const { items, columns } = helperGetColumsItems(report, this.mapColumns); // columns.splice(13, 1); //console.log("Colummna eliminada: ",columnas);
      /*

      //console.log("Columns: ",columns);

      const columnas = */
      this.OportuinitiesData = items;
      //console.log("Items: ",items);
      //console.log("el titulo klk", props.title);
      this.items = items;
      this.columns = columns;
      this.title = props.title;
      this.drawer = true;

      this.itemQuantity = this.items.length; // Gets total items to display it on the header of the drawer
      //console.log("items klk", this.items);
      this.tableLoading = false;

      //this.GetOportunitiesData();
    },
    handlerClose(done) {
      this.items = [];
      done();
    },
    CloseDetailDrawer() {
      this.dealDetailDrawer = false;
    },
    handleTableUpdate() {
      this.getItems();
      this.$emit("getUpdatedData");
    },
    refreshData() {
      this.$refs.table.refreshTable();
    },
    GetOportunitiesData() {
      this.loading = true;
      const date = new Date();
      const url = "/api/deals/DealReportByPhase";
      const parameters = {
        params: {
          companyID: this.currentCompany,
          Year: date.getFullYear(),
          DealsMonth: null,
          SellerId: this.employee,
          PhaseID: null,
          DateFilter: 5,
          UserID: null,
          Close: true,
          limit: 9999,
          Page: 1,
          //BySeller: this.detailProps.BySeller,
          //SellerId: this.detailProps.row.SellerId,
          SupportSellerId: this.currentUser.UserID,
          AgentId: null
        }
      };
      this.$http
        .get(url, parameters)
        .then((resp) => {
          /*
          console.log("Empleado: ", this.employee);
          console.log("Usuario: ", this.currentUser);
          console.log("Respuesta: ", resp);
          console.log("Rol: ", this.roles);
          console.log("Saller Id: ", this.sellerId);
          */
          const Items = resp.data;
          this.OportuinitiesData = Items;
          //console.log(this.OportuinitiesData);
          //console.log("op", Items);
          //console.log("klk", resp.data);
        })
        .catch((err) => {
          console.error("Error: ", err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    },
    employee() {
      this.getReportData();
    }
  }
};
</script>
